var _path, _path2, _path3, _path4, _path5, _circle, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFyndricon5(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 46.8L5.47167 47.1593C4.1632 48.049 2.74068 48.7582 1.24258 49.2675C1.13571 49.3039 1.10921 49.4428 1.19522 49.5159L9.9059 56.92C9.96358 56.969 10.044 56.9813 10.1137 56.9517L11 56.575L12.5 56.15L14 55.725L14.5283 55.6352C15.8404 55.4121 17.169 55.3 18.5 55.3H20.5H22C22.9982 55.3 23.9947 55.3841 24.9788 55.5514L26 55.725L31 56.575L34 57H36.5H38H40.5H41.1969C42.0641 57 42.9297 56.9269 43.7846 56.7816C44.5936 56.6441 45.3903 56.4423 46.1672 56.1782L47.5 55.725C48.819 55.1644 50.0072 54.3361 50.9894 53.2925L53.5 50.625L55 48.925L56.5 46.8C57.1629 45.6731 57.6523 44.4528 57.9517 43.1801L58 42.975L58.4571 41.4208C58.4856 41.3241 58.5 41.2238 58.5 41.123C58.5 40.6998 58.2471 40.3175 57.8576 40.152L57.8229 40.1372C57.6127 40.0479 57.3802 40.0255 57.1568 40.0729L56.1568 40.2854C55.7215 40.3779 55.303 40.5366 54.9158 40.7561L54.7424 40.8543C54.2503 41.1332 53.8028 41.4845 53.4151 41.8964L46.5849 49.1536C46.1972 49.5655 45.7451 49.9194 45.2529 50.1983C44.757 50.4794 44.2163 50.6853 43.6587 50.8038C42.8948 50.9661 42.1052 50.9661 41.3413 50.8038L41.0682 50.7457C40.6901 50.6654 40.3194 50.5534 39.9601 50.4108L33.0253 47.66C33.0166 47.6566 33.0169 47.6442 33.0257 47.6413L35.5 46.8L37.5424 46.304C38.5107 46.0688 39.5036 45.95 40.5 45.95H42.0523C42.6506 45.95 43.2156 45.6751 43.5849 45.2043L43.7757 44.961C43.921 44.7757 44 44.547 44 44.3116C44 44.0029 43.8645 43.7098 43.6292 43.5099L42.9799 42.9579C42.6637 42.6891 42.2933 42.4914 41.894 42.3783L40.8683 42.0877C39.9636 41.8313 39.0199 41.7408 38.0829 41.8205L36.1484 41.9849C35.0517 42.0781 33.9488 42.0729 32.853 41.9695L30 41.7L25.5 40.85L23.4918 40.4707C21.8438 40.1594 20.1535 40.1439 18.5 40.425L14.5 41.7C12.5058 42.5476 10.6082 43.6067 8.84001 44.8592L8.5 45.1L6 46.8Z",
    stroke: "url(#paint0_linear_6663_27008)",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.1898 39.75L33.5 29.7648L34.8102 39.75H32.1898Z",
    stroke: "url(#paint1_linear_6663_27008)",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M41.9493 26.6097L43.7586 26.3175L43.6947 26.6891L43.3884 28.1726L42.7739 29.9587L42.1564 31.4541L41.573 32.5845C41.4047 32.9106 41.1624 33.1928 40.8654 33.4086C40.5671 33.6253 40.2219 33.7689 39.8578 33.8277L39.6838 33.8558L39.8432 34.843L39.6838 33.8558C39.201 33.9338 38.7065 33.8961 38.2411 33.7458L37.9951 33.6663L37.6878 34.6179L37.9951 33.6663C37.6458 33.5535 37.3271 33.3621 37.0634 33.1067C36.8765 32.9256 36.7203 32.7153 36.601 32.4841L36.3489 31.9957L35.4932 32.4374L36.3489 31.9957C36.2794 31.861 36.2198 31.7215 36.1705 31.5782L36.1316 31.4654C36.0445 31.2121 36 30.946 36 30.6782C36 30.3614 36.0622 30.0476 36.1831 29.7548L36.2394 29.6185C36.4048 29.2179 36.6508 28.8556 36.9621 28.554L36.9621 28.554L36.9942 28.5229C36.9942 28.5229 36.9942 28.5229 36.9942 28.5229C37.3186 28.2087 37.7027 27.9626 38.1239 27.7994L38.9097 27.4949L38.9907 27.4636L38.6294 26.5311L38.9907 27.4636C39.9497 27.0919 40.9398 26.8062 41.9493 26.6097Z",
    stroke: "url(#paint2_linear_6663_27008)",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3019 25.2741L23.3004 25.2638L23.6712 25.334L25.1484 25.6695L26.9283 26.3432L28.4205 27.0209L29.4891 27.6276C29.8563 27.8361 30.1691 28.1285 30.4018 28.4808C30.6182 28.8085 30.76 29.1797 30.817 29.5683L30.8556 29.8311C30.9368 30.3841 30.8973 30.9481 30.7398 31.4844L30.643 31.8144C30.5343 32.1846 30.3458 32.5266 30.0908 32.8161C29.8969 33.0363 29.6677 33.2226 29.4126 33.3675L28.953 33.6284L29.4467 34.498L28.953 33.6284C28.8253 33.7009 28.6921 33.7634 28.5547 33.8154L28.9069 34.7459L28.5547 33.8154L28.4315 33.8621C28.1905 33.9533 27.9351 34 27.6775 34C27.3737 34 27.0733 33.935 26.7967 33.8093L26.6286 33.733L26.2533 34.5593L26.6286 33.733C26.2447 33.5586 25.9022 33.3049 25.6236 32.9885L25.5318 32.8844C25.2243 32.5352 24.9867 32.1301 24.8321 31.6912L24.5057 30.7645L24.4793 30.6895C24.1007 29.6148 23.8107 28.5109 23.6123 27.3888L23.3019 25.2741Z",
    stroke: "url(#paint3_linear_6663_27008)",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5 10.7693C36.7004 10.1367 35.2933 9.69733 34 9.66933M34 9.66933C32.4615 9.63667 31.0839 10.188 31.0839 11.692C31.0839 14.4613 37.5 13.0767 37.5 15.846C37.5 17.426 35.7921 18.1047 34 18.0533M34 9.66933V8M30.5 16.7693C31.2524 17.5627 32.6502 18.0147 34 18.0533M34 18.0533V20",
    stroke: "url(#paint4_linear_6663_27008)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 34,
    cy: 14,
    r: 10,
    stroke: "url(#paint5_linear_6663_27008)",
    strokeWidth: 2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6663_27008",
    x1: 3.17053,
    y1: 39.5423,
    x2: 10.9119,
    y2: 69.3487,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.185417,
    stopColor: "#F0592A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#253C77"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6663_27008",
    x1: 31.1887,
    y1: 23.4077,
    x2: 41.173,
    y2: 25.9908,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.185417,
    stopColor: "#F0592A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#253C77"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_6663_27008",
    x1: 35.3775,
    y1: 24.7308,
    x2: 44.6574,
    y2: 35.2945,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.185417,
    stopColor: "#F0592A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#253C77"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_6663_27008",
    x1: 21.7308,
    y1: 34.5848,
    x2: 33.1584,
    y2: 25.4586,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.185417,
    stopColor: "#F0592A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#253C77"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_6663_27008",
    x1: 30.7642,
    y1: 7.67692,
    x2: 41.1141,
    y2: 14.5496,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.185417,
    stopColor: "#F0592A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#253C77"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_6663_27008",
    x1: 23.8305,
    y1: 2.40769,
    x2: 44.2463,
    y2: 25.648,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.185417,
    stopColor: "#F0592A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#253C77"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFyndricon5);
export default __webpack_public_path__ + "static/media/fyndricon5.d03fd99209e72a3d9ae615bdb56e4bd0.svg";
export { ForwardRef as ReactComponent };